module.exports = __webpack_public_path__ + "quintype-logo-8e95812559a5fae5b0b6.svg";